import axios from "axios";
export async function getCurrentCity() {
  const response = await axios.request({
    url: "https://restapi.amap.com/v3/ip",
    method: "get",
    params: {
      key: process.env.VUE_APP_MAP_KEY,
      output: "json"
    }
  });
  return response.data.city;
}
